module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Australia: Monarchy, Nature and Beyond")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch003#introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch004#our-monarchy-system"
    }
  }, [_vm._v("Our Monarchy System")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch005#understanding-how-and-why-our-monarchy-system-works",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Understanding How and Why Our Monarchy System Works")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch006#the-credentials-of-the-monarchy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Credentials of the Monarchy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch007#the-mystique-of-our-system-ownership",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mystique of Our System-Ownership")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch008#reserve-rights-empowering-the-people",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reserve Rights – Empowering the People")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch009#a-brief-history",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Brief History")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch010#conventions-the-peoples-emotional-capital",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conventions – The People’s Emotional Capital")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch011#evolution-change-but-not-as-we-know-it",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evolution Change but Not as We Know It")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch012#head-of-state",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Head of State")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch013#who-should-be-our-governor-general",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Who Should Be Our Governor-General?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch014#importing-a-monarch-for-australia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Importing a Monarch for Australia")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch015#succession",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Succession")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch016#paul-keating-guilty-by-association",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Keating Guilty by Association")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch017#hereditary-conditioning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hereditary Conditioning")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch018#politicians",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Politicians")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch019#religion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch020#an-abstract-ideology",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Abstract Ideology")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch021#comment-and-summary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comment and Summary")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch022#appointing-our-governor-general",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appointing Our Governor-General")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#an-independent-speaker-for-parliament",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Independent Speaker for Parliament")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch023#suggestion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suggestion")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch024#appointing-judges",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appointing Judges")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch025#the-dismissal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dismissal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch026#the-party-system-is-the-party-over",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Party System Is the Party Over?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch027#final-summary-and-comment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Summary and Comment")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eb74dd3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/nav.vue
// module id = 60
// module chunks = 0